import React from 'react';
import { Chip } from '@mui/material';
import { ageHighlightBadgeSx } from '@components/contest/contestChromeShared';

/** Consistent age highlight — always placed at the trailing end of a header row. */
export const ContestAgeBadge: React.FC<{ age: string }> = ({ age }) => (
  <Chip label={age} size="small" sx={{ ...ageHighlightBadgeSx, flexShrink: 0 }} />
);
